import ExampleHelpButton from '../example-buttons/ExampleHelpButton.vue';

<hr />
## Note: Section Help

Each section has it's own more detailed **help information** for that section, you can view this by clicking the top right Button <ExampleHelpButton /> button inside that section.

<hr />
